import { Component, Input, SimpleChanges, OnChanges } from '@angular/core';

@Component({
    selector: 'clink-cascade-select',
    templateUrl: './cascade-select.component.html',
    styleUrls: ['./cascade-select.component.less'],
})
export class CascadeSelectComponent implements OnChanges {
    @Input() targetArr = []; // 数据源级联数组
    @Input() groupFieldLabelKey = 'name'; // 字段组名称字段
    @Input() groupFieldValueKey = 'value'; // 字段组值字段
    @Input() groupChildKey = 'children'; // 字段组子集字段
    @Input() fieldLabelKey = 'name'; // 字段名称字段
    @Input() fieldValueKey = 'value'; // 字段组值字段
    @Input() selectFields = []; // 已选择字段
    @Input() defaultFields = []; // 默认选中的fields，重置时会恢复此默认值

    constructor() {}

    ngOnChanges(changes: SimpleChanges): void {
        // 初始时间变更
        if (changes?.selectFields) {
            if (!changes?.selectFields?.currentValue || !Array.isArray(changes?.selectFields?.currentValue)) {
                // 无选中数据 || 选中数据非数组
                if (Array.isArray(this.defaultFields)) {
                    this.selectFields = [...this.defaultFields];
                } else {
                    this.selectFields = [];
                }
            }
            if (this.targetArr && Array.isArray(this.targetArr)) {
                this.classifyColumns(this.targetArr);
            }
        }
    }

    /**
     * 初始化字段组的checked和indeterminate属性
     *
     * @param {Array<any>} list
     * @memberof GroupDisplayFieldsComponent
     */
    classifyColumns(list: Array<any>): void {
        list.forEach((item) => {
            if (Array.isArray(item[this.groupChildKey]) && item[this.groupChildKey]?.length) {
                // 初始化字段组子集属性
                let allChildrenChecked = true;
                let noChildChecked = true;
                item[this.groupChildKey].forEach((child) => {
                    const find = this.selectFields.find((it) => (it[this.fieldValueKey] || it) === child[this.fieldValueKey]);
                    child.checked = !!find;
                    if (find) {
                        noChildChecked = false;
                    } else {
                        allChildrenChecked = false;
                    }
                });
                if (allChildrenChecked) {
                    item.checked = true;
                    item.indeterminate = false;
                } else if (noChildChecked) {
                    item.checked = false;
                    item.indeterminate = false;
                } else {
                    // 有一部分选择
                    item.checked = false;
                    item.indeterminate = true;
                }
            } else {
                // 字段组无子集
                const find = this.selectFields.find((it) => (it.value || it) === item[this.groupFieldValueKey]);
                item.checked = !!find;
            }
        });
    }

    /**
     * 更新父级选中状态
     *
     * @param {*} section
     * @returns
     * @memberof CascadeSelectDialogComponent
     */
    updateParentCheckbox(section): void {
        if (!section) {
            return;
        }

        let allChildrenChecked = true;
        let noChildChecked = true;

        for (const child of section[this.groupChildKey]) {
            if (!child.checked || child.indeterminate) {
                allChildrenChecked = false;
            }
            if (child.checked) {
                noChildChecked = false;
            }
        }

        if (allChildrenChecked) {
            section.checked = true;
            section.indeterminate = false;
        } else if (noChildChecked) {
            section.checked = false;
            section.indeterminate = false;
        } else {
            section.checked = false;
            section.indeterminate = true;
        }
    }

    /**
     * 当前字段组全选/取消全选
     *
     * @param {*} checked
     * @param {*} section
     * @memberof GroupDisplayFieldsComponent
     */
    setSectionAllSelect(checked: boolean, section): void {
        section.checked = checked;

        if (Array.isArray(section[this.groupChildKey]) && section[this.groupChildKey]?.length) {
            // 处理子集字段选中状态
            section.children.forEach((child) => {
                // 判断是否可修改
                if (!child.disabled) {
                    child.checked = checked;
                    const _index = this.selectFields.findIndex((it) => it === child[this.fieldValueKey]);
                    if (checked) {
                        if (_index === -1) {
                            this.selectFields.push(child[this.fieldValueKey]);
                        }
                    } else {
                        if (_index > -1) {
                            this.selectFields.splice(_index, 1);
                        }
                    }
                }
            });
        } else {
            if (!section.disabled) {
                const _index = this.selectFields.findIndex((it) => it === section[this.groupFieldValueKey]);
                if (checked) {
                    if (_index === -1) {
                        this.selectFields.push(section[this.groupFieldValueKey]);
                    }
                } else {
                    if (_index > -1) {
                        this.selectFields.splice(_index, 1);
                    }
                }
            }
        }
        this.updateParentCheckbox(section);
    }

    /**
     * 处理checkBox点击事件
     *
     * @param {*} checked 选中状态
     * @param {*} item 字段
     * @param {*} section 字段所在组
     * @memberof GroupDisplayFieldsComponent
     */
    changeCheckBox(checked: boolean, item, section): void {
        item.checked = checked;
        const fieldIndex = this.selectFields.findIndex((it) => it === item[this.fieldValueKey]);
        if (checked) {
            if (fieldIndex === -1) {
                this.selectFields.push(item[this.fieldValueKey]);
            }
        } else {
            if (fieldIndex > -1) {
                this.selectFields.splice(fieldIndex, 1);
            }
        }
        this.updateParentCheckbox(section);
    }
}
